import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../providers/AuthProvider";
import brandingConfig from "../brandingConfig";

const LogoutPage = () => {
  const { setToken } = useAuth();
  const navigate = useNavigate();
  
  const [branding, setBranding] = useState(brandingConfig['default']);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const currentHostname = window.location.hostname;
      setBranding(brandingConfig[currentHostname] || brandingConfig['default']);
    }
  }, []);

  const handleLogout = () => {
    setToken();
    localStorage.removeItem('userinfo');
    localStorage.removeItem('role');
    if (localStorage.getItem('user_avatar')) {
      localStorage.removeItem('user_avatar');
    }
    localStorage.removeItem('last_login');
    localStorage.removeItem('last_ip');
    localStorage.removeItem('theme');
    navigate("/", { replace: true });
  };

  setTimeout(() => {
    handleLogout();
  }, 3 * 1000);

  return (
    <div className="h-screen flex justify-center items-center">
      <div className="text-center">
        <div className="flex justify-center">
          <img className="animate-pulse" src={branding.logoCollapsed} alt="Loading" width={160} />
        </div>
        <h1 className="text-xl font-bold text-gray-800 dark:text-gray-500 animate-pulse pt-4">Logging out..</h1>
      </div>
    </div>
  );
};

export default LogoutPage;
